'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _dashboard = require('./dashboard');

var _dashboard2 = _interopRequireDefault(_dashboard);

var _products = require('./products');

var _products2 = _interopRequireDefault(_products);

var _productParts = require('./product-parts');

var _productParts2 = _interopRequireDefault(_productParts);

var _productPage = require('./product-page');

var _productPage2 = _interopRequireDefault(_productPage);

var _orders = require('./orders');

var _orders2 = _interopRequireDefault(_orders);

var _coupons = require('./coupons');

var _coupons2 = _interopRequireDefault(_coupons);

var _newsletter = require('./newsletter');

var _newsletter2 = _interopRequireDefault(_newsletter);

var _users = require('./users');

var _users2 = _interopRequireDefault(_users);

var _images = require('./images');

var _images2 = _interopRequireDefault(_images);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var componentModule = _angular2.default.module('app.modules', [_dashboard2.default, _products2.default, _productParts2.default, _productPage2.default, _orders2.default, _coupons2.default, _newsletter2.default, _users2.default, _images2.default]).name;

exports.default = componentModule;

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/modules/index.js
 **/